const css = `.K7bSXq__loadingSpinner{z-index:99999;width:100%;height:100%;background-color:var(--base-backgrounds-default);justify-content:center;align-items:center;display:none;position:absolute}.K7bSXq__loadingSpinner.K7bSXq__visible{display:flex}.K7bSXq__target{background-color:inherit;display:contents}.K7bSXq__target.K7bSXq__downloading{background-color:var(--base-backgrounds-default);display:block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"loadingSpinner":"K7bSXq__loadingSpinner","target":"K7bSXq__target","visible":"K7bSXq__visible","downloading":"K7bSXq__downloading"};
